import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { AlertCircle } from 'lucide-react';

/**
 * In-app confirm dialog. Replaces `window.confirm` which some browsers
 * (or window-blur conditions) silently dismiss → operator clicks an action
 * and nothing visible happens. This is always visible until clicked away.
 */
export function ConfirmDialog({ open, title, message, confirmLabel = 'Onayla', cancelLabel = 'Vazgeç', destructive = false, onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4" onClick={onCancel} data-testid="planning-confirm-dialog">
      <Card className="max-w-sm w-full p-5" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start gap-3 mb-4">
          <AlertCircle className={`h-5 w-5 mt-0.5 ${destructive ? 'text-red-500' : 'text-amber-500'}`} />
          <div className="flex-1">
            <h3 className="text-sm font-semibold mb-1">{title}</h3>
            <p className="text-xs text-slate-600 dark:text-slate-300 whitespace-pre-line">{message}</p>
          </div>
        </div>
        <div className="flex gap-2 justify-end">
          <Button size="sm" variant="ghost" onClick={onCancel} data-testid="planning-confirm-cancel">{cancelLabel}</Button>
          <Button
            size="sm"
            variant={destructive ? 'destructive' : 'default'}
            onClick={onConfirm}
            data-testid="planning-confirm-ok"
          >
            {confirmLabel}
          </Button>
        </div>
      </Card>
    </div>
  );
}
